import { gql } from '@apollo/client';

export const insertQuestionnaireMutation = gql`
  mutation ($object: dans_fund_questionnaire_insert_input!) {
    insert_dans_fund_questionnaire_one(object: $object) {
      id
    }
  }
`;
